export const ONE_MONTH = "Within 1 month from now";
export const THREE_MONTHS = "Within 3 months from now";
export const SIX_MONTHS = "Within 6 months from now";
export const YEAR = "Within a year from now";